module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: _vm.parentClass,
    staticStyle: {
      "margin": "5px"
    }
  }, [_c('img', {
    attrs: {
      "id": "image",
      "src": _vm.cropImageUrl
    }
  })]), _vm._v(" "), (_vm.aspectRatio && _vm.aspectRatio['desktop']) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('button', {
    class: _vm.crops.mobile.done ? 'done' : '',
    on: {
      "click": function($event) {
        _vm.cropMode = 'mobile'
      }
    }
  }, [_vm._v("MOBILE")]), _vm._v(" "), _c('button', {
    class: _vm.crops.desktop.done ? 'done' : '',
    on: {
      "click": function($event) {
        _vm.cropMode = 'desktop'
      }
    }
  }, [_vm._v("DESKTOP")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f1ae280"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/image/imageCrop.vue
// module id = 654
// module chunks = 1